export enum NotificationType {
  FILE = 'FILE',
  TICKET = 'TICKET',
  MISC = 'MISC'
}
